/**
 * Component Registry for Daymark Uptown
 * 
 * Inherits from @vibesites-weidner-apartment-homes/theme-weidner-classic-theme and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-weidner-apartment-homes/theme-weidner-classic-theme/registry';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { LuxuryDefinition } from './components/LuxuryDefinition';
import { Footer } from './components/Footer';
import { UrbanStudioLife } from './components/UrbanStudioLife';
import { VideoTourEmbed } from './components/VideoTourEmbed';
import { NeighborhoodMap } from './components/NeighborhoodMap';
import { FloorplansList } from './components/FloorplansList';
import { TabbedCallouts } from './components/TabbedCallouts';
import { PinnedCallouts } from './components/PinnedCallouts';
import { Penthouse } from './components/Penthouse';
import { PetPolicy } from './components/PetPolicy';

/**
 * Property-specific component overrides.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  Header,
  Hero,
  LuxuryDefinition,
  Footer,
  UrbanStudioLife,
  VideoTourEmbed,
  NeighborhoodMap,
  FloorplansList,
  TabbedCallouts,
  PinnedCallouts,
  Penthouse,
  PetPolicy,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
